import React from 'react';
import { Model } from "@singularsystems/neo-core";
import { Neo, NeoGrid } from "@singularsystems/neo-react";
import { Catalogue } from "@singularsystems/neo-react-services"
import * as Roles from "../../../AccessControl/Models/Commands/Security/Roles";
import OrganisationServiceProviderLookup from '../../../Common/Models/OrganisationServiceProviderLookup';
import { AppService, Types } from '../../StaticData/StaticDataTypes';
import OrganisationServiceProviderSearchCriteria from '../../../Common/Models/OrganisationServiceProviderSearchCriteria';
import OrganisationServiceProvider from '../../../Common/Models/OrganisationServiceProvider';

export default class OrganisationServiceProviderPagedCatalogueEntry extends Catalogue.PagedCatalogueEntry<OrganisationServiceProviderSearchCriteria, OrganisationServiceProviderLookup, OrganisationServiceProvider> {

    constructor(private apiClient = AppService.get(Types.ApiClients.GeneralApiClient),
        private serviceProviderApiClient = AppService.get(Types.ApiClients.ServiceProviderApiClient),
        private taskRunner = AppService.get(Types.Neo.TaskRunner)) {
        super("Organisation Service Providers", OrganisationServiceProviderSearchCriteria, OrganisationServiceProviderLookup, OrganisationServiceProvider, {
            sortBy: "organisationName",
            fetchInitial: true,
            pageSize: 10,
            pageSizeOptions: [10, 20, 50],
        });
    }

    public organisations = this.apiClient.getStaticOrganisationList().then((res) => {
        return res.data;
    });

    public serviceProviders = this.serviceProviderApiClient.getServiceProviderListByCriteria("").then((res) => {
        return res.data;
    });

    public get editRole() {
        return Roles.OrganisationConfigurationsRoles.Edit;
    }

    public getPagedDataEndpoint() {
        return this.apiClient.getOrganisationServiceProviders;
    }

    public getSaveEndpoint() {
        return this.apiClient.saveOrganisationServiceProvider;
    }

    public renderCriteria(criteria: OrganisationServiceProviderSearchCriteria, meta: Model.TransformMetaType<OrganisationServiceProviderSearchCriteria>) {
        return (
            <Neo.GridLayout lg={3}>
                <Neo.FormGroup label="Organisation Name" bind={meta.organisationName} />
                <Neo.FormGroup label="Service Provider Name" bind={meta.serviceProviderName} />
            </Neo.GridLayout>
        )
    }

    public renderRow(item: OrganisationServiceProviderLookup, meta: Model.TransformMetaType<OrganisationServiceProviderLookup>) {
        return (
            <NeoGrid.RowGroup>
                <NeoGrid.Row>
                    <NeoGrid.Column display={meta.organisationName} />
                    <NeoGrid.Column display={meta.serviceProviderName} />
                    <NeoGrid.ButtonColumn deleteButton={{ onClick: () => this.removeItem(this.taskRunner, item) }} />
                </NeoGrid.Row>
            </NeoGrid.RowGroup>
        );
    }

    public renderFormControls(item: OrganisationServiceProvider, meta: Model.TransformMetaType<OrganisationServiceProvider>) {
        return <div>
            <Neo.GridLayout md={3}>
                <Neo.FormGroup
                    bind={meta.organisationId}
                    select={{ items: this.organisations, displayMember: "organisationName", valueMember: "organisationId" }}>
                </Neo.FormGroup>
                <Neo.FormGroup
                    bind={meta.staticServiceProviderId}
                    select={{ items: this.serviceProviders, displayMember: "serviceProviderName", valueMember: "staticServiceProviderId" }}>
                </Neo.FormGroup>
            </Neo.GridLayout>
        </div>
    }
}